import { IconButton, Popover } from '@material-ui/core';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { div, span } from "lqx-react";
import React, { useEffect, useRef } from 'react';
export const FrequencyPicker = ({ $value, label, stepMinutes = 1 }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const hoursRef = useRef(null);
  const minutesRef = useRef(null);
  const listHoursRef = useRef(null);
  const listMinutesRef = useRef(null);
  const activeHH = useRef(null);
  const activeMM = useRef(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (!$value.value) {
      $value.set('00:02')
    }
  }, [$value.value]);

  const convertHour = (value) => {
    if (+value > 23) {
      return '23'
    } else if (+value < 0) {
      return '00'
    }
    return value
  }

  const convertMinutes = (value) => {
    if (+value > 60 - stepMinutes) {
      return `${60 - stepMinutes}`
    } else if (+value < 0) {
      return '00'
    }
    return value
  }

  const correctHours = (e) => {
    const data = $value.value.split(':');
    data[0] = haveZero(+e.target.value);
    $value.set(data.join(':'));
  }

  const findNearestNumber = (number, step) => {
    for (let num = number - step; num < number; num++) {
      if (num % step == 0) {
        return num;
      }
    }
  }

  const correctMinutes = (e) => {
    const data = $value.value.split(':');
    if (+e.target.value % stepMinutes !== 0) {
      data[1] = haveZero(findNearestNumber(+e.target.value, +stepMinutes))
    }
    data[1] = haveZero(+data[1]);
    $value.set(data.join(':'));
  }

  const handleChange = (e, type) => {
    if (!+e.target.value && +e.target.value !== 0) {
      return;
    }
    const data = $value.value.split(':');
    if (type == 'HH') {
      data[0] = convertHour(e.target.value)
    } else {
      data[1] = convertMinutes(e.target.value)
    }
    $value.set(data.join(':'));
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const haveZero = (num) => {
    if (num < 10) {
      return `0${num}`
    }
    return `${num}`
  }

  const dataGenerate = (from: number, to: number, step: number = 1) => {
    const data = []
    for (let item = from; item < to; item = item + step) {
      data.push(`${haveZero(item)}`)
    }
    return data;
  }

  useEffect(() => {
    setTimeout(() => {
      if (activeHH.current) {
        activeHH.current.scrollIntoView({ block: 'center', inline: 'nearest' });
        activeMM.current.scrollIntoView({ block: 'center', inline: 'nearest' });
      }
    }, 0);
  }, [activeHH.current, activeMM.current])

  const checkActive = (value, type) => {
    const data = $value.value.split(':')
    if (type === 'HH' && data[0] == value) {
      return true
    } else if (type === 'MM' && data[1] == value) {
      return true
    }
    return false
  }

  const changeData = (value, type) => () => {
    const data = $value.value.split(':')
    if (type === 'HH') {
      data[0] = value
    } else if (type === 'MM') {
      data[1] = value
    }
    $value.set(data.join(':'))
  }

  const handleFocus = (event) => {
    event.target.select()
  };

  const handleChangeKey = (type, step) => {
    const data = $value.value.split(':')
    const currentId = type === 'HH' ? 0 : 1;
    const upTo = type === 'HH' ? 24 : 60
    if (+data[currentId] + step < upTo && + data[currentId] + step >= 0) {
      data[currentId] = haveZero(+data[currentId] + step)
    }
    $value.set(data.join(':'));
  }

  const keyControl = (type, ref) => (e) => {
    const step = type == 'HH' ? 1 : stepMinutes;
    const codeNext = type == 'HH' ? 39 : 37;
    if (e.keyCode == codeNext) {
      setTimeout(() => ref.current.focus(), 0)
    } else if (e.keyCode == 38) {
      handleChangeKey(type, step)
    } else if (e.keyCode == 40) {
      handleChangeKey(type, -step)
    }
  }

  const keyControlArrows = (ref, direction) => () => {
    const step = direction == 'top' ? -100 : 100;
    ref.current.scrollTo({ top: ref.current.scrollTop + step, behavior: 'smooth' });
  }

  return ($value.value ?
    <TimeWrapper>
      {/* <Label>{label}</Label> */}
      <TimeInputWrapper>
        <input
          ref={hoursRef}
          value={$value.value.split(':')[0]}
          type='text'
          onChange={e => handleChange(e, 'HH')}
          onFocus={handleFocus}
          onKeyDown={keyControl('HH', minutesRef)}
          onBlur={correctHours}
          maxLength={2}
        />
        <span style={{ margin: 'auto' }}>:</span>
        <input
          ref={minutesRef}
          value={$value.value.split(':')[1]}
          type='text'
          onChange={e => handleChange(e, 'MM')}
          onFocus={handleFocus}
          onKeyDown={keyControl('MM', hoursRef)}
          onBlur={correctMinutes}
          maxLength={2}
        />
        <IconButton aria-label="Access Time" onClick={handleClick} style={{ width: '20px', margin: 0, padding: 0, marginLeft: '8px' }}>
          <AccessTimeIcon fontSize="medium" />
        </IconButton>
      </TimeInputWrapper>
      <Popover
        id={'1'}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
      >
        <div style={{
          width: '100px',
          height: '320px',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <ArrowWrapper style={{ height: '20px' }}>
            <span>HH</span>
            <span>MM</span>
          </ArrowWrapper>
          <ArrowWrapper>
            <IconButton aria-label="Up" onClick={keyControlArrows(listHoursRef, 'top')} style={{ width: '20px', margin: 0, padding: 0 }}>
              <KeyboardArrowUpIcon fontSize='large' />
            </IconButton>
            <IconButton aria-label="Up" onClick={keyControlArrows(listMinutesRef, 'top')} style={{ width: '20px', margin: 0, padding: 0 }}>
              <KeyboardArrowUpIcon fontSize='large' />
            </IconButton>
          </ArrowWrapper>
          <TimeListWrapper>
            <TimeList ref={listHoursRef}>
              {
                dataGenerate(0, 24).map((i, id) => (
                  <ItemBox
                    key={id}
                    active={checkActive(i, 'HH')}
                    onClick={changeData(i, 'HH')}
                    ref={checkActive(i, 'HH') ? activeHH : null}
                  >{i}</ItemBox>
                ))
              }
            </TimeList>
            <TimeList ref={listMinutesRef}>
              {
                dataGenerate(0, 60, stepMinutes).map((i, id) => (
                  <ItemBox
                    key={id}
                    active={checkActive(i, 'MM')}
                    onClick={changeData(i, 'MM')}
                    ref={checkActive(i, 'MM') ? activeMM : null}
                  >{i}</ItemBox>
                ))
              }
            </TimeList>
          </TimeListWrapper>
          <ArrowWrapper>
            <IconButton aria-label="Down" onClick={keyControlArrows(listHoursRef, 'bottom')} style={{ width: '20px', margin: 0, padding: 0 }}>
              <KeyboardArrowDownIcon fontSize='large' />
            </IconButton>
            <IconButton aria-label="Down" onClick={keyControlArrows(listMinutesRef, 'bottom')} style={{ width: '20px', margin: 0, padding: 0 }}>
              <KeyboardArrowDownIcon fontSize='large' />
            </IconButton>
          </ArrowWrapper>
        </div>
      </Popover>
    </TimeWrapper>
    : <span />
  );
}

const TimeWrapper = div({
  width: 95,
  height: 40,
  display: 'flex',
  flexDirection: 'column',
  margin: '0 0 0 4px'
})

// const Label = span({
//   fontSize: '9px',
//   color: '#DEDEDE',
//   fontFamily: 'Montserrat',
//   fontWeight: 500,
// });

const ArrowWrapper = div({
  width: '100%',
  height: '25px',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0 13px 0 13px',
  background: '#f4f4f5',
})

const TimeListWrapper = div({
  width: '100px',
  height: '250px',
  display: 'flex',
  justifyContent: 'center',
  background: '#f4f4f5',
});

const TimeList = div({
  width: '50px',
  height: '250px',
  overflow: 'scroll',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: 'Montserrat',
  fontWeight: 500,
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '-ms-overflow-style': 'none',
  'scrollbar-width': 'none',
});

const ItemBox = div({
  padding: '0 5px 0 5px',
  margin: '2px',
  textAlign: 'center',
  background: (props: any) => props.active ? '#09bbcf' : 'white',
  color: (props: any) => props.active ? 'white' : 'black',
  cursor: 'pointer',
  '&:hover': {
    background: '#81dee9',
    color: 'white'
  }
});

const TimeInputWrapper = div({
  margin: '4px 0',
  width: '90px',
  height: '33px',
  display: 'flex',
  border: '1px solid #E3E9ED',
  fontSize: '14px',
  fontFamily: 'Montserrat',
  fontWeight: 500,
  '& input': {
    width: '25px',
    border: 'none',

  },
  '& input:focus': {
    outline: 'none'
  }
})

